export const en_home = {
  main: "Change the way you see the world with Ubiq",
  sub: "Ubiq is a graphics-specific UGC media platform where creators post graphics and users can follow their favorite creators. We create a creator token economy by rewarding ad views with our own tokens, not only to creators but also to users."
}